import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { SpinnerLoadingService } from '../services/spinner-loading.service';
import { SKIP_LOADING } from '@ribera-web/app-token';

let activeRequests = 0;

export const HttpLoadingInterceptor: HttpInterceptorFn = (req, next) => {

  const spinnerService = inject(SpinnerLoadingService);
  
  const skip = req.context.get(SKIP_LOADING);

  if (skip) {
    return next(req);
  }

  if (activeRequests === 0) {
    spinnerService.show();
  }
  activeRequests++;

  return next(req).pipe(
    finalize(() => {
      activeRequests--;
      if (activeRequests <= 0) {
        activeRequests = 0;
        spinnerService.hide();
      }
    })
  );
};